<template>
  <NModal @closeModal="$emit('closeModal')" class="video-modal">
    <!-- Показываем контент ТОЛЬКО если объект video и его описание существуют -->
    <template v-if="video && video.videoDescription">
      <AppTitle mode="h3" class="modal_video_title">
        <template v-slot:title>{{ video.videoDescription }}</template>
      </AppTitle>

      <div class="video-modal__video">

        <!-- ВАРИАНТ 1: ЧИСТЫЙ ПЛЕЕР ДЛЯ SAFARI (iOS / macOS) -->
        <video
          v-if="isAppleSafari"
          :poster="video.posterName ? getPosterUrl(video.posterName) : ''"
          controls
          playsinline
          crossorigin="use-credentials"
          class="native-apple-player"
        >
          <source :src="currentVideoUrl" type="application/vnd.apple.mpegurl" />
        </video>

        <!-- ВАРИАНТ 2: СТОРОННИЙ ПЛЕЕР ДЛЯ ОСТАЛЬНЫХ (Chrome, Firefox, Android) -->
        <!-- Обернули в обычный div, чтобы верстка не плыла и v-if/v-else работал строго -->
        <div v-else class="chrome-player-wrapper">
          <Vue3VideoPlayer
            v-if="video.sourceHlsIndex"
            :src="getVideoUrl(video.sourceHlsIndex)"
            :cover="video.posterName ? getPosterUrl(video.posterName) : ''"
            :core="HLSCore"
            playsinline
          />

          <Vue3VideoPlayer
            v-if="!video.sourceHlsIndex && video.externalLinkUrl"
            :src="getVideoUrl(video.externalLinkUrl)"
            :cover="video.posterName ? getPosterUrl(video.posterName) : ''"
            :core="HLSCore"
            :viewCore="viewCore"
            :resolution="'auto'"
            playsinline
          />
        </div>

      </div>
    </template>
  </NModal>
</template>


<script>
import NModal from "./NModal.vue";
import AppTitle from "@/elements/AppTitle.vue";

import { Vue3VideoPlayer } from "@cloudgeek/vue3-video-player";
import { t } from "@/utils/translate";
import { ref, computed } from "vue";
import HLSCore from "@cloudgeek/playcore-hls";

export default {
  emits: ["closeModal"],
  components: { NModal, Vue3VideoPlayer, AppTitle },
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const players = ref({});

    // Проверяем, является ли браузер Safari (на Mac или iPhone)
    const isAppleSafari = computed(() => {
      if (typeof window !== "undefined") {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const noMSE = !("MediaSource" in window || "WebKitMediaSource" in window);
        return isSafari || noMSE;
      }
      return false;
    });

    // Метод для базовой сборки путей
    const getVideoUrl = (path) => {
      if (!path || path === 'undefined' || path === '{path}') return '';
      return 'https://navigator.eurekacenter.ru/video' + path;
    };



    // УДАЛИТЕ СТАРЫЙ currentVideoUrl И ЗАМЕНИТЕ НА ЭТОТ ЧИСТЫЙ ВАРИАНТ:
    const currentVideoUrl = computed(() => {
      let activePath = "";

      if (props.video.sourceHlsIndex) {
        activePath = props.video.sourceHlsIndex;
      } else if (props.video.externalLinkUrl) {
        activePath = props.video.externalLinkUrl;
      }

      if (!activePath) return "";

      // Никаких подмен! Просто отдаем оригинальный путь,
      // так как сервер теперь сам знает, куда перенаправить плеер
      return 'https://navigator.eurekacenter.ru/video' + activePath;
    });




    const getPosterUrl = (path) => {
      if (!path || path === 'undefined' || path === '{path}') return '';
      return 'https://navigator.eurekacenter.ru/video' + path;
    };

    function viewCore(id, player) {
      players.value[id] = player;
    }

    return {
      t,
      HLSCore,
      viewCore,
      getVideoUrl,
      getPosterUrl,
      isAppleSafari,
      currentVideoUrl
    };
  },
};

</script>

<style lang="scss">

.video-modal {
  padding-bottom: 30px;

  // Находим корневую белую карточку внутри компонента NModal для адаптации ширины
  :deep(.n-modal-content),
  :deep(.modal-box),
  & {
    width: 95% !important; // Модалка занимает 95% ширины экрана телефона
    max-width: 800px !important; // Ограничение на больших мониторах ПК
    margin: 0 auto;
    border-radius: 16px;
    padding: 24px !important;
    box-sizing: border-box;
    background-color: #ffffff;
  }

  h3 {
    text-align: left;
    color: #ffffff; // Изменено на темный, так как фон модалки теперь белый
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.4;
  }

  // Зона видеоплеера
  &__video {
    width: 100% !important;
    max-width: 800px;
    margin: 0 auto;
    border-radius: 12px; // Сделали скругление чуть мягче
    overflow: hidden;
    display: block;
    background: #000000;

    // Магия жесткого удержания пропорций 16:9 на смартфонах
    aspect-ratio: 16 / 9 !important;
  }

  // Нативный плеер Safari (iOS / macOS)
  .native-apple-player {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important; // Видео вписывается без искажений
    display: block;
  }

  // Обертка плеера для Chrome / Android
  .chrome-player-wrapper {
    width: 100% !important;
    height: 100% !important;
    display: block;
  }

  // Пробиваем инкапсуляцию scoped для внутренних тегов библиотеки Vue3VideoPlayer
  :deep(.vue3-video-player),
  :deep(video),
  :deep(.vjs-tech),
  :deep(.vjs-poster) {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
  }

  // Адаптивность модалки под экраны компьютеров (от 768px и выше)
  @media (min-width: 768px) {
    :deep(.n-modal-content),
    :deep(.modal-box),
    & {
      padding: 32px !important;
    }

    h2 {
      font-size: 22px;
    }
  }
}

// =========================================================================
// 2. ОБЕРТКА СТРАНИЦЫ УРОКА И КНОПКА "НАЗАД"
// =========================================================================
.course-layout {
  padding: 16px !important; // Отступы от краев экрана смартфона
  background-color: #f8fafc !important; // Мягкий светло-серый фон страницы
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  // Стильная и контрастная кнопка-капсула "Назад"

}

// =========================================================================
// 3. СИНЯЯ КАРТОЧКА С ТЕКСТОМ И ОПИСАНИЕМ ЛЕКЦИИ
// =========================================================================
.course-layout-blue-card {
  background: linear-gradient(135deg, #2b7de9 0%, #1e5bb8 100%) !important; // Благородный легкий градиент
  border-radius: 16px !important;
  padding: 24px 20px !important;
  box-shadow: 0 10px 25px rgba(30, 91, 184, 0.15) !important; // Мягкая цветная тень под карточкой
  margin-top: 12px !important; // Слегка отодвинули её от черной плашки видеоплеера, добавив "воздуха"

  // Причесываем шрифт внутри синего блока под гайдлайны Навигатора
  h2, h3, p {
    color: #ffffff !important;
    font-family: "Comfortaa", sans-serif !important;
    line-height: 1.5 !important;
    letter-spacing: -0.01em;
    text-align: left;
  }

  p {
    font-size: 15px !important;
    opacity: 0.9; // Слегка приглушаем второстепенные строки (например, ФИО автора)
    margin-top: 6px;
  }
}

// =========================================================================
// 4. ГЛОБАЛЬНЫЙ ВЫЖИГ НАЛОЖЕНИЯ ЗАГЛОВКОВ НА СМАРТФОНАХ
// =========================================================================
@media (max-width: 768px) {
  // Полностью выключаем фоновую секцию с накладывающимся текстом
  .modal_video_title,
  [class*="modal_video_title"],
  .wave-section_page-title,
  [class*="wave-section_page-title"] {
    display: none !important;
  }
}
</style>

